import * as React from 'react';

import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { CreateCaseState } from 'state/knowledge-force/types';

import { ICreateSupportCaseFeedbackProps } from './types';

const Text = styled.p<{ success: boolean }>`
  font: ${brandFont.copyOne};
  color: ${p => (p.success ? p.theme.token('text-default') : p.theme.token('text-error'))};
`;

export const CreateSupportCaseFeedback = React.forwardRef<
  HTMLParagraphElement,
  ICreateSupportCaseFeedbackProps
>(
  (
    {
      createCaseState,
      errorMessage,
      successMessage,
      successMessage2,
      successMessage3,
      backlogMessage,
    },
    ref
  ) => {
    const message = (
      <>
        {successMessage}
        <br />
        {backlogMessage ? successMessage2 : successMessage3}
      </>
    );
    return (
      <Text
        ref={ref}
        data-testid="after-submission-message"
        success={createCaseState === CreateCaseState.SUCCESS}
      >
        {createCaseState === CreateCaseState.ERROR && errorMessage}
        <span data-testid="after-submission-message-success">
          {createCaseState === CreateCaseState.SUCCESS && message}
        </span>
      </Text>
    );
  }
);
